import { useState } from "react";
import Body from "./Body";
const SetupClasses = () => {
  const [genderWaysFilter, setGenderWaysFilter] = useState("");
  const [classInfoData, setClassInfoData] = useState([
    {
      class: "1",
    },
    {
      class: "4",
      sections: "3",
      board: "WBCHSC",
      affiliationList: ["AICTE", "NAAC"],
      totalSeats: 50,
      mode: "Offline",
    },
    {
      class: "9",
      sections: "3",
      board: "WBCHSC",
      affiliationList: ["AICTE", "NAAC"],
      totalSeats: 50,
      mode: "Online",
    },
    {
      class: "10",
      sections: "3",
      board: "WBCHSC",
      affiliationList: ["AICTE", "NAAC"],
      totalSeats: 50,
      mode: "Online",
    },
  ]);
  const handelEdit = (editedData) => {
    const updatedData = [...classInfoData]; // clone array
    const index = classInfoData.findIndex(
      (data) => data?.class?.toLowerCase() === editedData?.class?.toLowerCase()
    );

    if (index !== -1) {
      updatedData[index] = editedData; // update at same index
      setClassInfoData(updatedData);
    } else {
      // fallback: if not found, add new
      setClassInfoData([...classInfoData, editedData]);
    }
  };
  const handelDeleteData = (data) => {
    console.log(data);
  };
  const _this = {
    genderWaysFilter,
    setGenderWaysFilter,
    classInfoData,
    setClassInfoData,
    handelEdit,
    handelDeleteData,
  };
  return <Body {..._this} />;
};

export default SetupClasses;
